'use strict';

wbApp.factory('picturesSvc', ['$resource', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, notificationSvc, repositorySvc) {

        var jpgstr = 'data:image/jpeg;base64,';
        var pngstr = 'data:image/png;base64,';

        var Picture = $resource('/restapi/images', {}, {
            'query':  { method: 'GET', isArray: true },
           // 'update': { method: 'POST', url: '/Api/Subjects/Update' },
            'insert': { method: 'POST', url: '/restapi/images' },
            'delete': { method: 'DELETE', url: '/restapi/images' },
            'dashboard': { method: 'GET', isArray: true, url: '/restapi/images/dashboard' }
        });

        var pictures;
        var includesGlobal = false;

        function getAllAsync(refresh, includeGlobal) {
            if (!pictures || refresh || (!!pictures && includesGlobal != includeGlobal)) {
                includesGlobal = includeGlobal;
                pictures = repositorySvc.get(Picture, { includeGlobal: includeGlobal  || false });
            }
            return pictures;
        }
        
        function getDashboardImages() {
            return repositorySvc.customGet('dashboard', Picture, { includeGlobal: true });
        }

        function prepareImageData(imageData, originalFormat, errorCallback, imageType) {

            var data = {
                imageBase64: '',
                imageType: imageType || 0, // 0 - Generic, 1 - Profile, 3 - Dashboard
                imageFormatType: decodeImageTypeFromData(imageData),
                convertToImageFormatType: originalFormat
            }

            switch (data.imageFormatType) {
                case 0:
                    data.imageBase64 = imageData.substring(pngstr.length);
                    break;
                case 1:
                    data.imageBase64 = imageData.substring(jpgstr.length);
                    break;
                default:
                    var errorReason = $translate.instant('TXT_ALERT_UNSUPPORTED_IMAGE_TYPE');
                    notificationSvc.notifyError($translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'), errorReason);

                    if (!!errorCallback) {
                        errorCallback(errorReason);
                    }
                    return null;
            }

            return data;
        }
        
        function  insertDashboard(imageData, successCallback, errorCallback) {
            let data = prepareImageData(imageData, 1, errorCallback, 3);
            if (!data) {
                return;
            }
            return repositorySvc.insert(
                Picture,               // $resource
                pictures,              // collection
                data,                  // entity
                successCallback,
                errorCallback);            
        }

        function insert(imageData, originalFormat, successCallback, errorCallback) {

            var data = prepareImageData(imageData, originalFormat, errorCallback);
            if (!data) {
                return;
            }

            return repositorySvc.insert(
                Picture,               // $resource
                pictures,              // collection
                data,                  // entity
                successCallback,
                errorCallback);
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                Picture,               // $resource
                pictures,              // collection
                data,                  // entity
                successCallback,       // successCallback
                errorCallback,
                { imageUrl: data.imageUrl },
                'imageUrl');
        }

        // -1 unknown, 0 - png, 1 - jpeg
        function decodeImageTypeFromData(imageData) {
            if (imageData.lastIndexOf(jpgstr, 0) === 0) {
                // jpeg
                return 1;
            } else if (imageData.lastIndexOf(pngstr, 0) === 0) {
                // png
                return 0;
            } else {
                return -1;
            }
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            remove: remove,
            decodeImageTypeFromData: decodeImageTypeFromData,
            prepareImageData: prepareImageData,
            getDashboardImages: getDashboardImages,
            insertDashboard: insertDashboard
        }
    }
]);
